import { Controllers } from 'lib/enums/routes/_controllers';
import { IssuersRoutes } from 'lib/enums/routes/issuers';
import { IssuerDoc, IssuerWhole } from 'lib/interfaces/database/issuer';
import { BaseService } from 'services/_base';

export class IssuersService extends BaseService {
  private static instance: IssuersService;

  static getInstance(): IssuersService {
    if (!IssuersService.instance) {
      IssuersService.instance = new IssuersService();
    }

    return IssuersService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.issuers,
    });
  }

  search(payload: Partial<IssuerDoc>) {
    return this.POST(
      {
        uri: IssuersRoutes.Search,
      },
      payload
    )
      .then((result: IssuerWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: Partial<IssuerDoc>) {
    return this.POST(
      {
        uri: IssuersRoutes.CreateOne,
      },
      payload
    )
      .then((result: IssuerWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<IssuerDoc>) {
    return this.PUT(
      {
        uri: `${IssuersRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: IssuerWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
